module.exports = __webpack_public_path__ + "static/media/apple-company.eaebd910.jpg";